module.exports = __webpack_public_path__ + "fonts/6906d86.eot";